(async () => {
  const el = document.getElementById('ethical-commission-meetings')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/info/ethical-commission/meetings.vue'),
    },
  ]

  await clientRender({ components })
})()
